import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { Observable } from 'rxjs';

import { Customer } from '../submit-customer-dialog/submit-customer-dialog.component';

import { MatButton } from '@angular/material/button';

import { AssociateUserToOrderService } from './associate-user-to-order.service';
@Component({
  selector: 'orders-associate-user-to-order',
  imports: [CommonModule, GalaxyFormFieldModule, MatSelectModule, TranslateModule, ReactiveFormsModule, MatButton],
  templateUrl: './associate-user-to-order.component.html',
  styleUrl: './associate-user-to-order.component.scss',
})
export class AssociateUserToOrderComponent {
  customersControl: FormControl<Customer>;
  public customers$: Observable<Customer[]>;
  protected isCustomerControlInvalid$: Observable<boolean>;

  constructor(private readonly associateUserToOrderService: AssociateUserToOrderService) {
    this.customersControl = this.associateUserToOrderService.customersControl;
    this.customers$ = this.associateUserToOrderService.customers$;
    this.isCustomerControlInvalid$ = this.associateUserToOrderService.isCustomerControlInvalid$;
    this.customersControl.markAsUntouched();
  }

  protected addCRMContact() {
    this.associateUserToOrderService.addCRMContact();
  }
  protected compareCustomer(customer1: Customer, customer2: Customer) {
    return (
      customer1.email === customer2.email &&
      customer1.userId === customer2.userId &&
      customer1.firstName === customer2.firstName &&
      customer1.lastName === customer2.lastName
    );
  }
}
